import React, { useEffect, useState } from "react";
import { fetchDocs, fetchEmployees, updateDocVisibility } from "../services/api";
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/20/solid';
import moment from "moment";
import { Link } from "wouter";
import Swal from "sweetalert2";
import ComboboxAutocompleteAPI from "./combobox_autocomplete_api";



function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function DocsTable(props) {

  const { loading, token } = props
  const [docs, setDocs] = useState([])
  const [allDocs, setAllDocs] = useState([])
  const [fetching, setFetching] = useState(true)
  const [employees, setEmployees] = useState([])
  const [filteredEmployee, setFilteredEmployee] = useState(null)

  const filteredEmployeeSetter = (selected) => {
    setFilteredEmployee(selected)
    if (selected) {
      const newDocs = allDocs.filter((d) => d.employee?.cf == selected.cf)
      if (newDocs.length == 0) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...!',
          text: 'Non ci sono documenti per questo dipendente',
        })
        setFilteredEmployee(null)
        setDocs(allDocs)
      } else {
        setDocs(newDocs)
      }
    } else {
      setDocs(allDocs)
    }
  }



  useEffect(() => {
    if (token && !loading) {
      console.log(token)
      setFetching(true)
    }

    fetchEmployees(token, false, null, 'documents').then((res) => {
      if (res.length === 0) {
        setEmployees([])
        return
      }
      setEmployees(res)
      setFetching(false)
    }).catch((err) => {
      console.log(err)
      setFetching(false)
    })

    fetchDocs(token, false, 'documents')
      .then((res) => {
        if (res.length === 0) {
          setDocs([])
          setFetching(false)
          return
        }

        setDocs(res)
        setAllDocs(res)
        setFetching(false)
      })
      .catch((err) => {
        console.log(err)
        setFetching(false)
      })
  }, [token]);

  const handleVisibilityChange = (docId, currentVisibility) => {
    const message = currentVisibility
      ? 'Vuoi rendere il documento non visibile al dipendente?'
      : 'Vuoi rendere il documento visibile al dipendente?';

    Swal.fire({
      title: message,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sì, confermo',
      cancelButtonText: 'No, annulla',
    }).then((result) => {
      if (result.isConfirmed) {
        updateDocVisibility(token, docId, !currentVisibility)
          .then(() => {
            setDocs((prevDocs) =>
              prevDocs.map((doc) =>
                doc.id === docId
                  ? { ...doc, visible_to_employee: !currentVisibility }
                  : doc
              )
            );
            Swal.fire('Salvato!', '', 'success');
          })
          .catch((err) => {
            console.error(err);
            Swal.fire('Errore!', 'Si è verificato un errore durante l\'aggiornamento.', 'error');
          });
      }
    });
  };


  if (fetching) {
    return <div
      className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    >
      {/* <svg
        className="mx-auto h-12 w-12 text-gray-400"
        stroke="currentColor"
        fill="none"
        viewBox="0 0 48 48"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M8 14v20c0 4.418 7.163 8 16 8 1.381 0 2.721-.087 4-.252M8 14c0 4.418 7.163 8 16 8s16-3.582 16-8M8 14c0-4.418 7.163-8 16-8s16 3.582 16 8m0 0v14m0-4c0 4.418-7.163 8-16 8S8 28.418 8 24m32 10v6m0 0v6m0-6h6m-6 0h-6"
        />
      </svg> */}
      <div role="status">
        <svg className="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-purple-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
        </svg>
        <span className="sr-only">Loading...</span>
      </div>
      <span className="mt-2 block text-sm font-semibold text-gray-900">Caricamento...</span>
    </div>
  }

  if (docs.length == 0 && !fetching) {
    return <div
      className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    >
      {/*  */}
      <div role="status">
        <svg
          className="mx-auto h-12 w-12 text-gray-400"
          stroke="currentColor"
          fill="none"
          viewBox="0 0 48 48"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 14v20c0 4.418 7.163 8 16 8 1.381 0 2.721-.087 4-.252M8 14c0 4.418 7.163 8 16 8s16-3.582 16-8M8 14c0-4.418 7.163-8 16-8s16 3.582 16 8m0 0v14m0-4c0 4.418-7.163 8-16 8S8 28.418 8 24m32 10v6m0 0v6m0-6h6m-6 0h-6"
          />
        </svg>
      </div>
      
      <span className="mt-2 block text-sm font-semibold text-gray-900">Non risultano presenti documenti nel nostro database</span>
    </div>
  }


  return <div className="mt-8 flow-root">
    <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" style={{ height: '100vh'}}>
      <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
        {/* dropdown menu with group of all employee */}
        <div className="flex flex-row justify-end">
          <div className="relative inline-block text-left">
            <div className="mr-4">
              <ComboboxAutocompleteAPI
                getData={(query) => fetchEmployees(token, query, null, 'documents').then(res => res || [])}
                getDisplay={(dip) => dip.last_name && dip.first_name ? `${dip.last_name} ${dip.first_name}` : dip.cf}
                getId={(dip) => dip.id}
                onChange={filteredEmployeeSetter}
                currentValue={filteredEmployee}
                placeholder="Cerca dipendente..."
              />
            </div>
          </div>
        </div>
      </div>
      <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
        <table className="min-w-full">
          <thead className="bg-white">
            <tr>
              <th scope="col" style={{ width: '15%'}} className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3">
                Nome
              </th>
              <th scope="col" style={{ width: '15%'}} className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                Dipendente
              </th>
              <th scope="col" style={{ width: '40%'}} className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                Descrizione
              </th>
              <th scope="col" style={{ width: '10%'}} className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                Caricamento
              </th>
              <th scope="col" style={{ width: '10%'}} className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                Scadenza
              </th>
              <th scope="col" style={{ width: '10%'}} className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                Visibile al dipendente
              </th>
              <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-3">
                <span className="sr-only">Edit</span>
              </th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {Array.isArray(docs) && docs.length > 0 ? (
              docs.map((b, bIndex) => (
                <tr
                  key={b.id}
                  className={'border-gray-200 border-t'}
                >
                  <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-3" style={{ width: '15%'}}>
                    {b.name}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" style={{ width: '15%'}}>
                    <Link to={`/dipendenti/${b.employee?.cf}`}>
                      {b.employee?.cf?.toUpperCase()}
                    </Link>
                  </td>
                  <td className="whitespace-normal px-3 py-4 text-sm text-gray-500" style={{ overflowWrap: 'break-word', width: '40%' }}>
                    {b.description}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" style={{ width: '10%'}}>
                    {moment(b.created_at).format('DD/MM/YYYY HH:mm')}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" style={{ width: '10%'}}>
                    {b.due_date ? moment(b.due_date).format('DD/MM/YYYY') : 'Nessuna scadenza'}
                  </td>
                  <td className="px-3 py-4 flex justify-center" style={{ width: '100%', height: '100%' }}>
                    {b.visible_to_employee ? (
                      <EyeIcon
                        className="w-5 h-5 text-green-500 cursor-pointer"
                        onClick={() => handleVisibilityChange(b.id, b.visible_to_employee)}
                      />
                    ) : (
                      <EyeSlashIcon
                        className="w-5 h-5 text-red-500 cursor-pointer"
                        onClick={() => handleVisibilityChange(b.id, b.visible_to_employee)}
                      />
                    )}
                  </td>
                  <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-3">
                    <Link to={`/documenti/${b.id}`} className="inline-flex items-center rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                      Apri
                    </Link>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-4 text-sm text-gray-500">
                  Nessun documento disponibile
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  </div>
}